import React, { useEffect, useState, useRef } from "react";
import { Modal, ModalBody, Form, FormGroup, Label, Input } from "reactstrap";
import { Calendar } from "react-date-range";
import { enGB, srLatn } from "date-fns/locale";
import { format } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

//import "./modals.css"
import "../../Pages/pages.css"
import apiRequest from "../../api";



const RegularModal = ({
    isOpen,
    toggle,
    fetchReservations,
    selectedDate,
}) => {
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return localStorage.getItem('Language') || 'EN';
    });
    useEffect(() => {
        setSelectedLanguage(localStorage.getItem('Language') || 'EN');
    }, [isOpen]);
    const locale = selectedLanguage === 'RS' ? srLatn : enGB;
    const calendarRef = useRef(null);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [formDetails, setFormDetails] = useState({
        date: selectedDate,
        start: "",
        end: "",
        name: "",
        company: "",
        id: "",
        notes: "",
    });
    const [errors, setErrors] = useState({
        start: "",
        end: "",
        name: "",
        company: "",
        message:"",
    });
    const toggleModal = (date) => {
        setFormDetails({
            date: selectedDate,
            start: "",
            end: "",
            name: "",
            company: "",
            id: "",
            notes: "",
        });
        setErrors({
            start: "",
            end: "",
            name: "",
            company: "",
            message: "",
        });
        toggle();
    };

    useEffect(() => {
        setFormDetails((prevFormDetails) => ({
            ...prevFormDetails,
            date: selectedDate,
        }));
    }, [selectedDate])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {
            start: formDetails.start === "" ? "This field is required" : "",
            end: formDetails.end === "" ? "This field is required" : "",
            name: formDetails.name === "" ? "This field is required" : "",
            company: formDetails.company === "" ? "This field is required" : "",
        };
        setErrors({
            ...newErrors
        });

        if (newErrors.start || newErrors.end || newErrors.name || newErrors.company) {
            return;
        }

        // Convert the form details
        const formattedDate = format(formDetails.date, "yyyy-MM-dd"); // Format the date to YYYY-MM-DD
        const startTime = `${formDetails.start}:00`; // Append ':00' to start time
        const endTime = `${formDetails.end}:00`; // Append ':00' to end time
        const name = formDetails.name; // No change needed for name
        const company = formDetails.company; // No change needed for company

        // Create the request body
        const requestBody = {
            date: formattedDate,
            startTime: startTime,
            endTime: endTime,
            name: name,
            company: company,
            notes: formDetails.notes
        };

        // Make the POST request
        try {
            const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
            const response = await apiRequest('/api/reservations/create_reservation', 'POST', requestBody, token);

            // Handle the response
            console.log("Reservation created successfully:", response);
            fetchReservations();
            toggleModal(); // Close the modal after successful submission

        } catch (error) {
            try {
                // Parse the error message
                const errorData = JSON.parse(error.message);

                // Check if the body contains the error and starts with the desired text
                if (errorData.Body?.error?.includes("no available parking")) {
                    setErrors({
                        start: "",
                        end: "",
                        name: "",
                        message: selectedLanguage === "EN" ? "No available parking for selected time" : "Nema slobodnog parking mesta za izabrani termin"
                    });
                }
                else if (errorData.Body?.error?.includes("can't make reservation in the past")){
                    setErrors({
                        start: "",
                        end: "",
                        name: "",
                        message: selectedLanguage === "EN" ? "Can not make reservations in the past":"Ne možete napraviti rezervaciju u poršlosti",
                    });
                }
                else{
                    alert(error);
                }
            } catch (parseError) {
                console.error("Failed to parse error message:", parseError);
            }

        }
    };
    const handleDateChange = (date) => {
        console.log(date)
        setFormDetails({ ...formDetails, date: date });
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                calendarRef.current &&
                !calendarRef.current.contains(event.target) // Check if click is outside
            ) {
                setIsCalendarOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleInputChange = (e, field) => {
        const { name, value } = e.target;

        setFormDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
            ...(name === "start" && prevDetails.end < value ? { end: value } : {}), // Update "end" if necessary
        }));
    };
    
    return (
        <Modal isOpen={isOpen} toggle={toggleModal} className="custom-model">
            <ModalBody className="modal-content" id="style-10" style={{ backgroundColor: "#f5f5f5" }}>
                <Form>
                    
                    <div className="row justify-content-center mb-2" ref={calendarRef} >
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ?"Date":"Datum"} <sup className="text-danger">*</sup>
                                </Label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={format(formDetails.date, "dd.MM.yyyy")}
                                    onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                                    readOnly
                                    style={{ cursor: "pointer", borderRadius: 5 }}
                                />
                                <div className="calendar-container">
                                    {isCalendarOpen && (
                                        <Calendar
                                            date={formDetails.date}
                                            onChange={(date) => {
                                                setFormDetails((prevDetails) => ({
                                                    ...prevDetails,
                                                    date: date, // Update the date
                                                }));
                                                setIsCalendarOpen(false);
                                            }}
                                            locale={locale}
                                            color="#3d91ff"
                                            className="calendar-container"
                                        />
                                    )}
                                </div>
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ?"Start":"Početak"} <sup className="text-danger">*</sup>
                                </Label>
                                <Input
                                    type="time"
                                    name="start"
                                    value={formDetails.start}
                                    onChange={handleInputChange}
                                    className={`form-control text-center ${errors.start ? "input-error" : ""}`}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ?"End":"Kraj"} <sup className="text-danger">*</sup>
                                </Label>
                                <Input
                                    type="time"
                                    name="end"
                                    value={formDetails.end}
                                    onChange={handleInputChange}
                                    className={`form-control text-center ${errors.end ? "input-error" : ""}`}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "Guest's Name":"Ime Gosta"}<sup className="text-danger">*</sup>
                                </Label>
                                <Input
                                    type="text"
                                    name="name"
                                    value={formDetails.name}
                                    onChange={handleInputChange}
                                    className={errors.name ? "input-error" : ""}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label>
                                    {selectedLanguage === "EN" ? "Guest's Company" : "Kompanija Gosta"}<sup className="text-danger">*</sup>
                                </Label>
                                <Input
                                    type="text"
                                    name="company"
                                    value={formDetails.company}
                                    onChange={handleInputChange}
                                    className={errors.company ? "input-error" : ""}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-12">
                            <FormGroup>
                                <Label>{selectedLanguage === "EN" ? "Note":"Napomena"}</Label>
                                <textarea
                                    name="notes"
                                    className="form-control input-left"
                                    value={formDetails.notes}
                                    onChange={handleInputChange}
                                    rows="2"
                                    cols="50"
                                    placeholder={selectedLanguage === "EN"
                                        ? "License plate number (preferred)"
                                        : "Registarske tablice (poželjno)"}
                                />

                            </FormGroup>
                        </div>
                    </div>
                    {errors.message &&(
                        <div className="mb-3"
                            style={{
                                fontSize: "16px",
                                fontFamily: "jura-light",       // Text color
                                textAlign: "center",
                                color: "red",  // Centers the text horizontally
                            }}>
                            {errors.message}
                        </div>
                    )}
                    <FormGroup>
                        <div className="row">
                            <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                                <button
                                    className="model-btn-cancel btn btn-secondary rounded-2 py-1 px-5"
                                    onClick={toggleModal}
                                    type="button"
                                >
                                    {selectedLanguage === "EN" ? "Cancel":"Otkaži"}
                                </button>
                            </div>
                            <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                                <button
                                    className="model-btn btn btn-primary rounded-2 py-1 px-5"
                                    onClick={handleSubmit}
                                >
                                    {selectedLanguage === "EN" ? "Reserve":"Rezerviši"}
                                </button>
                            </div>
                        </div>
                    </FormGroup>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default RegularModal;
